import { AutoCompleteModule } from './../A2-utils/auto-complete/auto-complete.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { DirectivesModule } from '../../directives/directives.module';
import { GoogleMapsModule } from '../A2-utils/google-maps/google-maps.module';
import { MyDatePickerModule } from 'mydatepicker';

import { TrackerService } from './../../services/tracker.service';
import { VehiclesService } from '../vehicles/vehicles.service';
import { AutoSchedulerService } from './../auto-scheduler/auto-scheduler.service';
import { TrackerRoutingModule } from './tracker-routing.module';
import { TrackerComponent } from './components/tracker/tracker.component';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule } from '@angular/forms';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    TrackerRoutingModule,
    DirectivesModule,
    AgGridModule.withComponents([]),
    GoogleMapsModule,
    MyDatePickerModule,
    AutoCompleteModule,
    TextMaskModule,
    FormsModule,
    Trip2ThemeModule
  ],
  declarations: [TrackerComponent],
  providers: [TrackerService, VehiclesService, AutoSchedulerService ]
})
export class TrackerModule { }



// WEBPACK FOOTER //
// ./src/app/pages/tracker/tracker.module.ts